import { Link } from "react-router-dom";
import { createColumnHelper } from "@tanstack/react-table";
import { moneyDisplay } from "@icraftx/shared/v1";
import type { DeskTableFeatures } from "@/modules/shell/data-table";

export type JournalLineRow = {
  id: string;
  accountId: string;
  accountCode: string;
  accountName: string;
  debit: string;
  credit: string;
  memo: string | null;
};

const lineHelper = createColumnHelper<DeskTableFeatures, JournalLineRow>();

export function journalLineColumns(companySlug: string) {
  return lineHelper.columns([
    lineHelper.display({
      id: "account",
      header: "Account",
      size: 260,
      cell: ({ row }) => {
        const l = row.original;
        return (
          <div>
            <Link
              to={`/c/${companySlug}/gl/accounts/${l.accountId}`}
              className="no-underline"
            >
              <span className="font-mono text-xs">{l.accountCode}</span>{" "}
              {l.accountName}
            </Link>
            {l.memo ? (
              <div className="text-xs text-[var(--color-muted)]">{l.memo}</div>
            ) : null}
          </div>
        );
      },
    }),
    lineHelper.accessor("debit", {
      id: "debit",
      header: "Debit",
      size: 110,
      meta: { align: "right" },
      cell: (info) =>
        Number(info.getValue()) ? (
          <span className="font-mono tabular-nums">
            {moneyDisplay(info.getValue())}
          </span>
        ) : (
          "—"
        ),
    }),
    lineHelper.accessor("credit", {
      id: "credit",
      header: "Credit",
      size: 110,
      meta: { align: "right" },
      cell: (info) =>
        Number(info.getValue()) ? (
          <span className="font-mono tabular-nums">
            {moneyDisplay(info.getValue())}
          </span>
        ) : (
          "—"
        ),
    }),
  ]);
}
